import Button from "@mui/material/Button";

export default function PageNine() {
    return (
        <div class="text-light">
            <h1 className="text-center">
                Join Us
            </h1>
            <div className="mt-5 text-center">
                Join the music adventure of LeptonMusic, with the best talents across the world!

            </div>
            <div className="mt-5 text-center">
                <Button>
                    {/*<a  href="mailto:leptondao@163.com?subject=test&cc=sample@hotmail.com&subject=主题&body=内容">Contact Us</a>*/}
                    <a  href="https://m.liepin.com/company/13344309/">Contact Us</a>
                </Button>
            </div>

        </div>
    )
}